<template>
    <div  style="min-heihgt:600px">
        <div v-if="this.$store.state.loading_home&&this.loadingSlider" class="d-flex flex-row justify-content-center loading_card">
            <!-- LOADER -->
            <div class="loading_card_spinner">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3"
                    color="var(--primary-color)" />

            </div>
        </div>

        <div id="carouselExampleIndicators" class="carousel slide sections_carousel" data-bs-ride="carousel">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
                    aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                    aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
                    aria-label="Slide 3"></button>
            </div>
            <VueSlickCarousel v-bind="settings"  ref="carouselBanner"class="carousel-inner" dir="ltr">

                <div v-for="(item, idx) in sliders" :key="idx" class="carousel-item banners">
                    <img :src="item.image" class="banners w-100" alt="Slide 1" style="display:flex">
                </div>


            </VueSlickCarousel>

            <button @click="goPrevBanner" class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
                data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button @click="goNextBanner" class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
                data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>

        <!--  -->
        <div class="container">

            <!--  -->
            <div class="container my-5">
                <h2 class="title_section">{{ $t('Shop By Occasion') }}</h2>

                <!-- بداية الكاروسيل -->
                <div id="occasionCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
                    <div class="carousel-inner">

                        <!-- الشريحة 1 -->
                        <div class="carousel-item active sections_div_home">
                            <VueSlickCarousel  ref="carouselSections" v-bind="settingsSections" class="text-center" dir="ltr">

                                <!-- العنصر الأول: يظهر في الموبايل وفي الشاشات الكبيرة -->
                                <div v-for="(item, index) in this.sections" @click="$router.push({
                                    name: 'section',
                                    params: {
                                        storeName: $store.storeName,
                                        id: item.id,
                                        name: item.name,
                                        lang: $i18n.locale
                                    },
                                });" style="cursor:pointer"
                                    class="col-12 col-md-2 d-md-block card-hover-effect">
                                    <img :src="item.icon" class="circle-img section_home" alt="Congratulations">
                                    <p class="occasion-title">{{ (item.name).substring(0, 18) }}</p>
                                    <p class="occasion-count">{{ item.count }} {{ $t('products') }}</p>
                                </div>

                            </VueSlickCarousel>
                        </div>


                    </div>
                    <!-- أسهم التنقل -->
                    <button @click="goPrevSection" class="carousel-control-prev section_caursol_btn" type="button" data-bs-target="#occasionCarousel"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    </button>
                    <button  @click="goNextSection"class="carousel-control-next section_caursol_btn" type="button" data-bs-target="#occasionCarousel"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    </button>
                </div>

            </div>
            <!--  -->

            <h2 class="title_section">{{ $t('Explore Our Collections') }}</h2>
            <div id="occasionCarousel" class="carousel slide">
                <div class="carousel-inner">

                    <!-- الشريحة 1 -->
                    <div class="carousel-item active">
                        <VueSlickCarousel ref="carouselCategory" v-bind="settingsCategories" class="text-center"
                            dir="ltr">
                            <div v-for="(item, idx) in categories" :key="idx"
                                class="col-lg-2 col-md-4 col-6 occasion-item-category"  @click="goToSection(item)">
                                <div class="card3 zoom-img">
                                    <img :src="item.icon" class="img3_card_owl-item" />
                                    <div class="card-footer">
                                        <p class="title_card_owl-item">{{ (item.name).substring(0, 16) }}...</p>
                                    </div>
                                </div>
                            </div>
                        </VueSlickCarousel>
                    </div>



                </div>

                <!-- أسهم التنقل -->
                <button class="carousel-control-prev category_carousal" @click="goPrevCategory" type="button" data-bs-target="#occasionCarousel"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                </button>
                <button class="carousel-control-next category_carousal" @click="goNextCategory" type="button" data-bs-target="#occasionCarousel"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                </button>

            </div>


            <!--  -->
            <!-- pages -->
            <div class="row" style="margin-top: 55px;">

                <!-- القسم الأول -->
                <div class="col-lg-4 col-md-6 mb-4 div_home_section" @click="$router.push({
                    name: 'sections',
                    params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                    },
                });">
                    <div class=" card">

                        <img src="https://etrolley.net/store/theme13/assest/images/WhatsApp Image 2023-10-21 at 17.59.28_0bd20738.jpg "
                            alt="Our Collection" class="image_card">
                        <div class="div_on_card">
                            <button class="button_on_card"> {{ $t('OUR COLLECTION') }}</button>
                        </div>
                    </div>
                </div>

                <!-- القسم الثاني -->
                <div class="col-lg-4 col-md-6 mb-4 div_home_section" @click="$router.push({
                    name: 'products',
                    params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                    },
                });">
                    <div class=" card">
                        <img src="https://etrolley.net/store/theme13/assest/images/image00003.webp" alt="Events" class="section-image">
                        <div class="div_on_card">
                            <button class="button_on_card"> {{ $t('products') }}</button>
                        </div>
                    </div>
                </div>

                <!-- القسم الثالث -->
                <div class="col-lg-4 col-md-6 mb-4 div_home_section" @click="$router.push({
                    name: 'about',
                    params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                    },
                });">
                    <div class=" card">
                        <img src="https://etrolley.net/store/theme13/assest/images/IMG_6565.webp" alt="Subscriptions" class="section-image">
                        <div class="div_on_card">
                            <button class="button_on_card"> {{ $t('about') }}</button>
                        </div>
                    </div>
                </div>

            </div>
            <!-- end pages -->

            
         <!-- Start -->
    <section class="container product_home" v-if="this.$store.state.apperance_latest_products==1"
    >
      <div v-if="products.length==0" class="empty text-center center-text">

        <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif" />
        <br>

      </div>
      
       <div v-else class="mt-4">
                 
        <div class="d-flex justify-content-between">
        <h4 class="title_section">{{ $t('Latest products') }}</h4>
          <h4 class="title_section"  @click="$router.push({
                    name: 'products',
                    params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                    },
                });" >{{ $t('See More Items') }}</h4>        

        </div>

               <div  class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
   
                   <!-- المنتج الأول -->
                   <product v-for="(item, index) in this.products" :key="index" :name="item.name"
                       :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                       :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                       :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer"
                       :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount"
                       :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
                       :range_price="item.range_price"></product>
   
   
   
               </div>
               <!--  -->
            </div>
          

    </section><!--end section-->


         <!-- Start -->
    <section class="container product_home" v-if="this.$store.state.apperance_best_saller==1"
    >
      <div v-if="sallerProducts.length==0" class="empty text-center center-text">

        <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif" />
        <br>

      </div>
      
       <div v-else class="mt-4">
                 
        <div class="d-flex justify-content-between">
        <h4 class="title_section">{{$t('Best Seller Items')}}</h4>
          <h4 class="title_section"  @click="$router.push({
                    name: 'products',
                    params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                    },
                });" >{{ $t('See More Items') }}</h4>        

        </div>

               <div  class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
   
                   <!-- المنتج الأول -->
                   <product v-for="(item, index) in this.sallerProducts" :key="index" :name="item.name"
                       :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                       :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                       :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer"
                       :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount"
                       :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
                       :range_price="item.range_price"></product>
   
   
   
               </div>
               <!--  -->
            </div>
          

    </section><!--end section-->


         <!-- Start -->
    <section class="container product_home" v-if="this.$store.state.apperance_fetured_products==1">
      <div v-if="feautred_products_loading" class="empty text-center center-text">

        <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif" />
        <br>

      </div>
      
       <div v-else-if="feautredProducts.length!=0" class="mt-4">
                 
        <div class="d-flex justify-content-between">
        <h4 class="title_section">{{$t('Featured products')}}</h4>
          <h4 class="title_section"  @click="$router.push({
                    name: 'products',
                    params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                    },
                });" >{{ $t('See More Items') }}</h4>        

        </div>

               <div  class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
   
                   <!-- المنتج الأول -->
                   <product v-for="(item, index) in this.feautredProducts" :key="index" :name="item.name"
                       :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                       :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                       :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer"
                       :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount"
                       :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
                       :range_price="item.range_price"></product>
   
   
   
               </div>
               <!--  -->
            </div>
          

    </section><!--end section-->
            <!-- start posts -->
            <div class="container" v-if="posts.length > 0">
                <h2 class="title_section">{{ $t('blogs') }}</h2>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-12" v-for="(item, idx) in posts" :key="idx">
                        <div class="card4" :style="'background-image: url(' + item.image + ') ;'">

                            <div class="blog_post">{{ item.name }}</div>


                            <div class="s_blog_posts_post_subtitle text-white">{{ item.describtion }} &amp;
                            </div>

                            <div class="te_blog_post_date">
                                <span>{{ item.date }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- end posts -->

            <section>
                <br>
                <br>
                <div class="container" v-html="DBitems"></div>
            </section>

        </div>
        <!--  -->

    
    </div>
</template>

<script>

import VueSlickCarousel from 'vue-slick-carousel';
import product from "../components/one_product_list.vue";
export default {
    components: {

        VueSlickCarousel,
        product
    },
    data() {
        return {
            sliders: [{ icon: "path/to/icon1.jpg", name: "Category 1" },
            { icon: "path/to/icon2.jpg", name: "Category 2" },
            { icon: "path/to/icon3.jpg", name: "Category 3" },
            { icon: "path/to/icon4.jpg", name: "Category 4" },
            { icon: "path/to/icon5.jpg", name: "Category 5" },
            { icon: "path/to/icon6.jpg", name: "Category 6" },
            { icon: "path/to/icon7.jpg", name: "Category 7" },
            { icon: "path/to/icon8.jpg", name: "Category 8" },
            { icon: "path/to/icon7.jpg", name: "Category 7" },
            { icon: "path/to/icon8.jpg", name: "Category 8" },
            ],
            DBitems: null,
            loading: false,
            langChange: "",
            sort: 'id',
            order: 'desc',
            paginate: 12,
            section_length: 0,
            DBitems: null,

            loadingSection: false,
            loadingSlider: false,
            loadingProduct: true,
            loadingCategory: false,
            loadingPost: false,
            sections: [
                { icon: "path/to/icon1.jpg", name: "Category 1" },
                { icon: "path/to/icon2.jpg", name: "Category 2" },
                { icon: "path/to/icon3.jpg", name: "Category 3" },
                { icon: "path/to/icon4.jpg", name: "Category 4" },
                { icon: "path/to/icon5.jpg", name: "Category 5" },
                { icon: "path/to/icon6.jpg", name: "Category 6" },
                { icon: "path/to/icon7.jpg", name: "Category 7" },
                { icon: "path/to/icon8.jpg", name: "Category 8" },
                { icon: "path/to/icon7.jpg", name: "Category 7" },
                { icon: "path/to/icon8.jpg", name: "Category 8" },
            ],
            categories: [
                { icon: "path/to/icon1.jpg", name: "Category 1" },
                { icon: "path/to/icon2.jpg", name: "Category 2" },
                { icon: "path/to/icon3.jpg", name: "Category 3" },
                { icon: "path/to/icon4.jpg", name: "Category 4" },
                { icon: "path/to/icon5.jpg", name: "Category 5" },
                { icon: "path/to/icon6.jpg", name: "Category 6" },
                { icon: "path/to/icon7.jpg", name: "Category 7" },
                { icon: "path/to/icon8.jpg", name: "Category 8" },
                { icon: "path/to/icon7.jpg", name: "Category 7" },
                { icon: "path/to/icon8.jpg", name: "Category 8" },

            ],
            products: [
            ],
            best_products_loading:false,
            sallerProduct:[],
            feautred_products_loading:false,
            sallerProduct:[],
            feautredProducts:[],
            posts: [
            ],
            page: 1,
            count: 0,
            pageSize: 6,
            langChange: "",
            sort: 'id',
            order: 'desc',
            paginate: 6,
            type: 'new',
            settings: {
                "dots": true,
                "arrows": true,
                "prevArrow": '<button class="prev">❮</button>',
                "nextArrow": '<button class="next">❯</button>',
                "speed": 5000,
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "infinite": true,
                "autoplay": true,
                "autoplaySpeed": 5000,
                "rows": 1
            },
            settingsSections: {
                "infinite": true,
                "slidesToShow": 6,
                "speed": 500,
                "slidesPerRow": 1,

                rows: 1,
                arrows: true,
                 "centerMode": true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 2,
                            rows: 1,
                              "centerMode": true,

                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            rows: 2,
                             "centerMode": false,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            rows: 2,
                             "centerMode": false,
                        }
                    }
                ]
            },
            settingsCategories: {
                slidesToShow: 6, // عرض 6 عناصر في وقت واحد
                slidesToScroll: 1, // التمرير بعنصر واحد عند كل تغيير
                autoplay: true, // التشغيل التلقائي
                autoplaySpeed: 2000, // كل 3 ثوانٍ
                dots: false, // بدون نقاط التنقل
                arrows: true, // إظهار الأسهم
                infinite: true, // تشغيل اللانهاية
                 "centerMode": true,
                responsive: [
                    {
                        breakpoint: 1200, // شاشات كبيرة
                        settings: {
                            "centerMode": true,
                            slidesToShow: 6,
                        },
                    },
                    {
                        breakpoint: 992, // شاشات متوسطة
                        settings: {
                            slidesToShow: 4,
                            "centerMode": false,

                        },
                    },
                    {
                        breakpoint: 768, // شاشات صغيرة
                        settings: {
                            slidesToShow: 3,
                             "centerMode": false,
                        },
                    },
                    {
                        breakpoint: 480, // هواتف
                        settings: {
                            slidesToShow: 2,
                             "centerMode": false,
                        },
                    },
                ],
            },
            loading_featured_products:true,
        }
    },
    created() {
        //sliders

        this.loadingSlider = true;
        this.axios
            .get(
                this.$store.state.base_api_url + this.$store.storeName + "/sliders",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                    },
                }
            )
            .then((response) => {
                this.sliders = response.data.data.sliders;


            })
            .then(() => {
                this.loadingSlider = false;
                console.log('sliders section', this.sliders)

            });
        this.loadingSection = true;
        this.axios
            .get(
                this.$store.state.base_api_url + this.$store.storeName + "/sections/theme13",

                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                    }
                }

            )
            .then((response) => {
                this.sections = response.data.data;
                this.loadingSection = false

            })
            .then(() => (this.loadingSection = false));

        //categories
        this.axios
            .get(
                this.$store.state.base_api_url + this.$store.storeName + "/theme13/home/categories",

                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                    }
                }

            )
            .then((response) => {
                this.categories = response.data.data;
                this.loadingCategory = false
                console.log('response.data.data ', response.data.data)

            })
            .then(() => (this.loadingCategory = false));

        //posts
        this.axios
            .get(
                this.$store.state.base_api_url + this.$store.storeName + "/posts/theme13/home",

                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                    }
                }

            )
            .then((response) => {
                this.posts = response.data.data;
                this.loadingPost = false
                console.log('response.data.data ', response.data.data)

            })
            .then(() => (this.loadingPost = false));


            //products

            // new products
 this.axios
    .get(
      this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/new",
      
      {
        headers: {
          "Accept-Language": this.$i18n.locale,
          Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
        }
      }
      
    )
    .then((response) => {
      this.products = response.data.data;
     
    })
    .then(() => (this.loadingProduct = false));
            //end new products
            //

            //best saller
               this.best_products_loading = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/best_saller",
        
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }
        
      )
      .then((response) => {
        this.sallerProducts = response.data.data;
       
      })
      .then(() => (this.best_products_loading = false));
            //end best saller

            //feautred

            this.loading_featured_products=true;
this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/feautred",
        
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }
        
      )
      .then((response) => {
        this.feautredProducts = response.data.data;
       
      })
      .then(() => (this.loading_featured_products = false));
            //end feautred


        //about
        this.axios
            .get(
                this.$store.state.base_api_url +
                this.$store.storeName +
                "/pages/Aboutus",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                    },
                }
            )
            .then((response) => {
                this.DBitems = response.data.data.description;
            })
            .then(() => (this.loading = false));

    },
    watch: {
        langChange() {
            this.loadingSlider = true;
            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/sliders",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                        },
                    }
                )
                .then((response) => {
                    this.sliders = response.data.data.sliders;


                })
                .then(() => {
                    this.loadingSlider = false;
                    console.log('sliders section', this.sliders)

                });
            this.loadingSection = true;
            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/sections/theme13",

                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        }
                    }

                )
                .then((response) => {
                    this.sections = response.data.data;
                    this.loadingSection = false

                })
                .then(() => (this.loadingSection = false));

            //categories
            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/theme13/home/categories",

                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        }
                    }

                )
                .then((response) => {
                    this.categories = response.data.data;
                    this.loadingCategory = false
                    console.log('response.data.data ', response.data.data)

                })
                .then(() => (this.loadingCategory = false));

                // 



            //posts
            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/posts/theme13/home",

                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        }
                    }

                )
                .then((response) => {
                    this.posts = response.data.data;
                    this.loadingPost = false
                    console.log('response.data.data ', response.data.data)

                })
                .then(() => (this.loadingPost = false));


            //about
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/pages/Aboutus",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                        },
                    }
                )
                .then((response) => {
                    this.DBitems = response.data.data.description;
                })
                .then(() => (this.loading = false));
        },
    },
    updated() {
        this.langChange = this.$i18n.locale
    },

    methods: {
         goToSection(item) {
      this.$router.push({
        name: 'section',
        params: {
          storeName: this.$store.storeName,
          id: item.section_id,
          name: item.name,
          lang: this.$i18n.locale,
        },
      });
    },
  goNextSection() {
    this.$refs.carouselSection.next();
  },
  goPrevSection() {
    this.$refs.carouselSection.prev();
  },

   goNextCategory() {
    this.$refs.carouselCategory.next();
  },
  goPrevCategory() {
    this.$refs.carouselCategory.prev();
  },
   goNextBanner() {
    this.$refs.carouselBanner.next();
  },
  goPrevBanner() {
    this.$refs.carouselBanner.prev();
  },
}

};
</script>

<style scoped>
.carousel-container {
    width: 100%;
    padding: 20px;
}
</style>
